// import { mapCart } from "../mapping/root";

import { mapColorsList } from "../mapping/compare";

export default function ($api) {
    return {
        /**
         * Получить все цвета товаров
         *
         * @returns {Object}
         */
        getColorsList() {
            return $api.get("api/product/colors/").then(mapColorsList);
        },
    };
}
